module.exports = __webpack_public_path__ + "static/media/icon_preloader.cfd81238.gif";